<template>
    <time :datetime="time" class="date" v-if="time">{{ dateFormatted }}</time>
</template>

<script>
    import { DateTime } from 'luxon'

    export default {
        name: 'Timestamp',
        props: {
            format: {
                type: String,
                default: null
            },
            time: {
                type: String,
                required: true
            }
        },
        computed: {
            dateFormatted() {
                let format = this.format ? this.format : `dd/MM/yyyy ! HH:mm`
                let timeRaw = DateTime.fromISO(this.time, { locale: this.$i18n.locale })
                return timeRaw.toFormat(format).replace('!', this.$t('ui.timestamp.at'))
            }
        }
    }
</script>
